class AlgoliaIconCheckbox extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.render = this.render.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      iconSize: this.getAttribute('icon-size')
    }
  }

  /**
   * Returns the CSS styles.
   * @returns {string} The CSS style block as a string.
   */
  getStyle() {
    const style = document.createElement('style');
    const css = `
      .icon-checkbox,
      input[type="checkbox"] {
        cursor: pointer;
        display: inline-block;
        height: ${this.settings.iconSize}px;
        width: ${this.settings.iconSize}px;
      }

      input[type="checkbox"] {
        position: absolute;
        opacity: 0;
      }

      .icon-checkbox-checked,
      .icon-checkbox-unchecked {
        display: none;
      }

      input[type="checkbox"]:checked ~ span .icon-checkbox-checked,
      input[type="checkbox"]:not(:checked) ~ span .icon-checkbox-unchecked {
        display: inline-block;
      }
    `;

    style.appendChild(document.createTextNode(css));

    return style;
  }

  /**
   * Renders the icon content.
   * @returns {string} The rendered icon.
   */
  render() {
    const style = this.getStyle();
    const iconCheckboxChecked = this.querySelector('algolia-icon-checkbox-checked');
    const iconCheckboxUnchecked = this.querySelector('algolia-icon-checkbox-unchecked');
    const iconCheckboxCheckedContent = iconCheckboxChecked ? iconCheckboxChecked.render() : [];
    const iconCheckboxUncheckedContent = iconCheckboxUnchecked ? iconCheckboxUnchecked.render() : [];

    const span = document.createElement('span');
    span.classList.add('icon', 'icon-checkbox');

    iconCheckboxCheckedContent.forEach(element => span.appendChild(element));
    iconCheckboxUncheckedContent.forEach(element => span.appendChild(element));

    return [style, span];
  }
}

customElements.define("algolia-icon-checkbox", AlgoliaIconCheckbox);